import { useTheme } from 'foundations-theming/utils';
import { Space } from 'foundations-theming';
import { SectionProps } from './Section';
import { Height } from './Section.types';
import { CSS_SPECIFICITY } from '../../constants/CSSSpecificity';

export const useMargin = (
  use: SectionProps['use'],
  flush: SectionProps['flush']
): {
  marginTop: Height;
  marginBottom: Height;
} => {
  const theme = useTheme();

  const defaultStyles = {
    [CSS_SPECIFICITY.OVERRIDE]: {
      marginBottom: flush ? theme.space[0] : undefined,
    },

    '& > :last-child': {
      marginBottom: theme.space[0],
    },
  };

  if (use === 'default') {
    return {
      marginTop: theme.space[0],
      marginBottom: theme.space[400],
      ...defaultStyles,
    };
  }

  return {
    marginTop: theme.space[1000],
    marginBottom: theme.space[1000],
    ...defaultStyles,
  };
};

export const useHeight = (value: Height | undefined) => {
  const theme = useTheme();

  if (typeof value === 'number') {
    return `${value}px`;
  } else if (typeof value === 'string' && value.includes('px')) {
    return value;
  } else if (typeof value === 'string' && value.includes('%')) {
    return value;
  } else if (theme.space[value as Space] !== undefined) {
    return theme.space[value as Space];
  } else {
    return undefined;
  }
};
